interface BaseProperty {
  description: string;
}

export interface StringProperty extends BaseProperty {
  type: 'string';
  enum?: string[];
}

export interface NumberProperty extends BaseProperty {
  type: 'number';
}

export interface BooleanProperty extends BaseProperty {
  type: 'boolean';
}

export interface ObjectProperty extends BaseProperty {
  type: 'object';
  properties: Record<string, JsonProperty>;
  required: string[];
  additionalProperties: false;
}

export interface ArrayProperty extends BaseProperty {
  type: 'array';
  items?: JsonProperty;
}

export type JsonProperty = StringProperty | NumberProperty | BooleanProperty | ObjectProperty | ArrayProperty;

export const PROPERTY_TYPES = ['string', 'number', 'boolean', 'object', 'array'] as const;
export type PropertyType = (typeof PROPERTY_TYPES)[number];

// Type guard for StringProperty
export const isStringProperty = (property: JsonProperty): property is StringProperty => {
  return property.type === 'string';
};
